import {otto} from "@otto-ec/global-resources/nexus";
import {Aggregation} from "./aggregation";

otto.ft3.promo.aggregation.assignNamespace({
    init: () => new Aggregation().init()
})